import { Component, input, output, signal, effect, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GUIDE_CONTENT, findGuideSection } from './guide-content';
import { ProjectState } from '../../../dtos/project-state';

@Component({
  selector: 'app-project-guide',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './project-guide.component.html',
})
export class ProjectGuideComponent {
  readonly open = input(false);
  readonly projectState = input<ProjectState>(ProjectState.SETUP);
  readonly guideAnchor = input<string>();

  readonly openChange = output<boolean>();

  readonly GUIDE_CONTENT = GUIDE_CONTENT;
  readonly expandedStage = signal<string | null>(null);
  readonly activeSectionId = signal<string | null>(null);
  readonly panelOpen = signal(false);

  constructor() {
    effect(() => {
      if (this.open()) {
        this.panelOpen.set(true);
        const anchor = this.guideAnchor();
        if (anchor) {
          const found = findGuideSection(anchor);
          if (found) {
            this.expandedStage.set(found.stage.label);
            setTimeout(() => {
              const el = document.getElementById('guide-section-' + anchor);
              el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
              this.activeSectionId.set(anchor);
            }, 350);
          }
        } else {
          const state = this.projectState();
          const stage = GUIDE_CONTENT.find((s) => s.stage === state);
          if (stage) {
            this.expandedStage.set(stage.label);
          }
        }
      } else {
        this.panelOpen.set(false);
        this.activeSectionId.set(null);
      }
    });
  }

  toggleStage(label: string): void {
    this.expandedStage.set(this.expandedStage() === label ? null : label);
  }

  close(): void {
    this.openChange.emit(false);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open()) this.close();
  }

  isStageExpanded(label: string): boolean {
    return this.expandedStage() === label;
  }

  isSectionActive(id: string): boolean {
    return this.activeSectionId() === id;
  }

  readonly ProjectState = ProjectState;
}
